import { Component, Inject, OnInit } from '@angular/core';
import { FilesProvider } from '../../providers/files-provider';
import { DomSanitizer } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';
import { VgApiService, VgCoreModule } from '@videogular/ngx-videogular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose, MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { AsyncPipe, CommonModule, NgIf } from "@angular/common";
import { VgBufferingModule } from "@videogular/ngx-videogular/buffering";
import { MatButton } from "@angular/material/button";
import { VgControlsModule } from "@videogular/ngx-videogular/controls";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { TranslateModule } from "@ngx-translate/core";
import { FlexLayoutModule } from "@angular/flex-layout";

@Component({
  selector: 'files-video-player-dialog',
  providers: [],
  styleUrls: ['./video-player-dialog.scss'],
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogClose,
    MatButton,
    MatProgressSpinner,
    MatDialogActions,
    MatDialogContent,
    AsyncPipe,
    TranslateModule,
    FlexLayoutModule,
    CommonModule,
    NgIf,
    VgCoreModule,
    VgBufferingModule,
    VgControlsModule,
  ],
  templateUrl: './video-player-dialog.html'
})
export class FilesVideoPlayerDialogComponent implements OnInit {
    public src: string = '';
    public type?: string = 'video/mp4';
    public title: string = '';

    private api: VgApiService;

    constructor(
        public dialog: MatDialogRef<FilesVideoPlayerDialogComponent>,
        private sanitizer: DomSanitizer,
        private _files: FilesProvider,
        @Inject(MAT_DIALOG_DATA) private _data : any
    ) {
        this.title = this._data.title;
        this.src = this._data.src;
        // this.type = this._data.type;
        this.api = new VgApiService();
    }

    public ngOnInit(): void {
        //
    }

    public onPlayerReady($event: VgApiService) {
        this.api = $event;

        this.api.getDefaultMedia().subscriptions.canPlay.subscribe(
            () => {
                this.api.play();
            }
        );
    }
}
